import { EnrichedEntity } from '@eppendorf/vnls-audit-event-client';
import { NotificationRule } from '@eppendorf/vnls-notifications-utils';

import { SimpleDeviceDisplay } from '$features/audit-events/components/simple-device-display/simple-device-display';
import { NotificationDetailCondition } from '$features/notifications/detail/notification-detail-condition';
import { NotificationDetailCreatedInfo } from '$features/notifications/detail/notification-detail-created-info';
import { NotificationDevicesInfo } from '$features/notifications/detail/notification-detail-devices';
import { NotificationDetailRecipient } from '$features/notifications/detail/notification-detail-recipient';
import useFetchDevices from '$features/notifications/detail/useFetchDevices';

export interface NotiRuleDisplayData {}

export interface NotiRuleDisplayProps {
  metadata: NotificationRule;
}

export function NotiRuleDisplay({ metadata }: NotiRuleDisplayProps) {
  const filteredSubjects = metadata.subjects.filter(
    (subject) => subject.type === 'device',
  );
  const { devices, errors } = useFetchDevices(filteredSubjects);

  return (
    <div className="p-top-l flex__dir--column">
      {!errors?.length && (
        <NotificationDevicesInfo
          devices={devices || []}
          fetchError={errors?.length > 0}
        />
      )}
      {errors?.length > 0 &&
        metadata.subjects.map((subject) => (
          <SimpleDeviceDisplay
            key={subject.id}
            device={[subject as unknown as EnrichedEntity]}
          />
        ))}
      <NotificationDetailCondition
        tags={metadata.tags}
        categories={metadata.categories}
        devices={devices || []}
        selectedDeviceType={metadata.selectedDeviceType}
      />
      <NotificationDetailRecipient
        escalationLayers={metadata.escalationLayers || []}
        tags={metadata.tags ?? []}
        notificationCadence={metadata.notificationCadence}
        notificationSendDelaySeconds={metadata.notificationSendDelaySeconds}
      />

      <NotificationDetailCreatedInfo data={metadata} />
    </div>
  );
}
